module.exports = __webpack_public_path__ + "src/assets/video/howToPlayAttack.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlayAttack.gif
// module id = ./src/assets/video/howToPlayAttack.gif
// module chunks = 0